import { render } from "./ModalAccessDcRemove.vue?vue&type=template&id=b15c6c7a"
import script from "./ModalAccessDcRemove.vue?vue&type=script&lang=js"
export * from "./ModalAccessDcRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__